import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatDividerModule} from '@angular/material/divider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TagModule} from '../tag/tag.module';
import {ActionsInspectorComponent} from './actions-inspector/actions-inspector.component';

import {AnnotationInspectorComponent} from './annotation-inspector/annotation-inspector.component';
import {AssetInspectorComponent} from './asset-inspector/asset-inspector.component';
import {AuthorInspectorComponent} from './author-inspector/author-inspector.component';
import {GroupInspectorComponent} from './group-inspector/group-inspector.component';
import {InspectorComponent} from './inspector/inspector.component';
import {TagInspectorComponent} from './tag-inspector/tag-inspector.component';

import {ThumbnailInspectorComponent} from './thumbnail-inspector/thumbnail-inspector.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TagModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatInputModule,
        MatFormFieldModule,
        MatChipsModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatBottomSheetModule,
        InspectorComponent,
        AssetInspectorComponent,
        ThumbnailInspectorComponent,
        TagInspectorComponent,
        AuthorInspectorComponent,
        ActionsInspectorComponent,
        GroupInspectorComponent,
        AnnotationInspectorComponent,
    ],
    providers: [{ provide: MAT_BOTTOM_SHEET_DATA, useValue: {} }],
    exports: [InspectorComponent],
})
export class InspectorModule {}
